import React, { useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { classNames } from "primereact/utils";
import { BsExclamationCircleFill } from "react-icons/bs";

interface Props {
    showModal: boolean;
    setShowModal: (state: boolean) => void;
    onSaveMarkup: (data: any) => void;
    cancelAction?:()=>void,
}
type FormData = {
    savecomment: any;
};
export const SaveMarkup: React.FC<Props> = ({
    showModal = false,
    setShowModal = () => {},
    onSaveMarkup = () => {},
    cancelAction=()=>{},

}) => {
  
    const {
        control,
        handleSubmit,
        formState: { errors },
        watch,
    } = useForm<FormData>({
        defaultValues: {
            savecomment: null,
        },
    });
    const saveComment = watch("savecomment");
    const addForm: any = useRef();
    const renderFooter = () => {
        return (
            <>
                <Button label="Cancel" onClick={() =>{cancelAction(); setShowModal(false)} }className="cancel btn" />
                <Button label="OK" className="update btn" autoFocus onClick={formSubmitHandler}/>
            </>
        );
    };

    const getFormErrorMessage = (name) => {
        return (
          errors[name] && (
            <span className="tooltip-text">
              <BsExclamationCircleFill />
              {errors[name].message}
            </span>
          )
        );
      };

      const formSubmitHandler = (data: any) => {
        addForm.current.requestSubmit();
      };

      const onFormSubmit = (data: any) => {
        onSaveMarkup && onSaveMarkup(saveComment)
      };
    
      const onError = (errors: any, e: any) => {};


    return (
        <>
            <Dialog
                header="Markup"
                visible={showModal}
                style={{ width: "40vw" }}
                onHide={() => setShowModal(false)}
                footer={renderFooter()}
                className="display-settings selectsite"
            >
                <form
                 onSubmit={handleSubmit(onFormSubmit, onError)}
                 ref={addForm}
                >

                    <div className="field col-12 md:col-4 mt-2 pt-3">
                        <span className="p-float-label">
                            <Controller
                                name="savecomment"
                                control={control}
                                rules={{
                                    required: "Comment",
                                }}
                                render={({ field, fieldState }) => (
                                    <InputTextarea
                                        id="savecomment"
                                        className={classNames("w-100 error-tooltip", { error: fieldState.invalid })}
                                        {...field}
                                    />
                                )}
                            />
                            <label className="mandatory" htmlFor="savecomment">
                            Comment
                            </label>
                            {getFormErrorMessage("savecomment")}
                        </span>
                    </div>


                </form>
            </Dialog>

        </>
    );
};

export default SaveMarkup;
